import h5 from './h5'
import pay from './pay'
import ticket from './ticket'
import gaotie from './gaotie'
import defray from './defray'

export default {
  ticket,
  pay,
  h5,
  gaotie,
  defray
}



// WEBPACK FOOTER //
// ./src/request/transformers/index.js